import React, { useState } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { Modal, Fade, Backdrop } from '@material-ui/core';

import AppOpinion from '../../Forms/AppOpinion';
import ImageWebp from '../../../utils/imageProcess/ImageWebp';
import ModalThanksOpinion from '../../Modal/ModalThanksOpinion';
import { validationAppOpinion } from '../../../utils/validations';
import { sendAppOpinion } from '../../../configs/environments/firebase/firebaseApp';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';

import './CardOpinionLanding.scss';

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: 560,
    borderRadius: 4,
    padding: 16,
    margin: 0,
    boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none',
    },
    '@media(max-width: 560px)': {
      width: 328
    }
  },
  infoWrapper: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
  },
  name: {
    fontSize: 24,
    color: '#10587f',
    textAlign: 'left',
    marginBottom: 16,
    fontWeight: 'bold',
    '@media(max-width: 560px)': {
      marginBottom: 8,
    }
  },
  subname: {
    fontSize: 14,
    color: '#484848',
    textAlign: 'center',
    maxWidth: 376,
    '@media(max-width: 560px)': {
      maxWidth: 296,
    }
  },
  buttons: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  ButtonBase: {
    margin: '0 0 0 16px',
    minWidth: '136px !important',
    width: 'initial',
  },
  closeContainer: {
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    '@media(max-width: 560px)': {
      marginBottom: 16,
    }
  },
  formContainer: {
    width: 368,
    '@media(max-width: 560px)': {
      width: 296,
    }
  }
});

const CardOpinionLanding = ({ showLoading, hideLoading }) => {
  const [open, setOpen] = useState(false);
  const [thanksModal, setThanksModal] = useState(false);
  const classes = useStyles();

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseThanks = () => {
    setThanksModal(false)
  }

  const handleSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);
    showLoading();

    let body =  {
      "name": values.name,
      "email": values.email,
      "phoneNumber": values.phone,
      "commentary": values.commentary,
      "termsConditions": values.termsAndConditions
    }

    //console.log('comentario', body)

    sendAppOpinion(body)
    .then( () => {
      hideLoading()
      setOpen(false)
      setThanksModal(true)
    })
    .catch(error => console.log(error))
  }

  const initialValues = {
    name: '',
    email: '',
    phone: '',
    commentary: '',
    termsAndConditions: false,
  };

  return (
    <div className="opinionLanding">
      <div className="opinionLanding_image">
        <ImageWebp
          srcWebp="/img/LandingClient/opinions/webp/logo-white.webp"
          src="/img/LandingClient/logo-white.svg"
          alt="logo contacta abogado"
        />
        {/* <img src='/img/LandingClient/opinions/logo-white.svg' alt='logo contacta abogado'/> */}
      </div>

      <div className="opinionLanding_card">
        <div className="opinionLanding_info">
          <p>
            Para nosotros en Contacta Abogado® tu experiencia es lo más
            importante.
          </p>
          <span onClick={() => setOpen(true)}>Dejar mi opinión</span>
        </div>
      </div>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div onClick={handleClose} className={classes.closeContainer}>
              <img src="/img/icons/close.svg" alt="close" />
            </div>
            <div className={classes.infoWrapper}>
              <div>
                <p className={classes.name}>Escríbenos tu experiencia</p>
              </div>

              <div className={classes.subname}>
                <span>
                  Comparte con nosotros tu experiencia con el sitio web de
                  Contacta Abogado®, cuéntanos si te fue fácil encontrar un
                  abogado en nuestro sitio y cómo ha sido tu interacción con él.
                </span>
              </div>

              <div className={classes.formContainer}>
                <Formik
                  initialValues={initialValues}
                  validationSchema={validationAppOpinion}
                  onSubmit={handleSubmit}
                  render={(props) => <AppOpinion {...props} />}
                />
              </div>
            </div>
          </div>
        </Fade>
      </Modal>

      <ModalThanksOpinion open={thanksModal} handleClose={handleCloseThanks}/>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
})

export default connect(null, mapDispatchToProps)(CardOpinionLanding);
